/*eslint no-undef: "error"*/
import history from '../Navigation';

const CheckAuth = () => {
  const auth = localStorage.getItem('auth');
  var currentPath = window.location.pathname;
    if (auth !=='' && auth !== null) {
      const accesstokendata =  localStorage.getItem('access_token');
      const readData = JSON.parse(accesstokendata);
      const expiryDate =  readData.userdata.exp;
      const currentDateData = new Date();
      const currentDate = Date.parse(currentDateData);
      const currentDateString = currentDate / 1000;
      if(currentDateString > expiryDate){
            history.push('/');
            localStorage.removeItem('access_token');
            localStorage.removeItem('auth');
            localStorage.removeItem('customerData');
            localStorage.removeItem('workData');
            localStorage.removeItem('techData');
            localStorage.removeItem('jobCountData');
            localStorage.removeItem('siteID');
            localStorage.removeItem('unsyu');
            localStorage.removeItem('profiledata');
            localStorage.removeItem('permissions');
          // window.location.href ='/';
        // if(currentPath ==='/create-job' || currentPath ==='/my-work'){
        //   window.location = "/";
        // }
      }else{
        if(currentPath ==='/'){
          const permissionsdata =  localStorage.getItem('permissions');
          const permissionsreadData = JSON.parse(permissionsdata);
          const filteredData = permissionsreadData.filter(obj => {
            return obj.PermissionCode === 'VIEW_JOB' || obj.PermissionCode === 'APPROVE_JOB' || obj.PermissionCode === 'COMPLETE_JOB' || obj.PermissionCode === 'SCHEDULE_JOB';
          });
          if(filteredData.length > 0){
            if(filteredData[0].PermissionCode === 'VIEW_JOB' || filteredData[0].PermissionCode === 'APPROVE_JOB' || filteredData[0].PermissionCode === 'SCHEDULE_JOB'){
              window.location = "/pm-schedule";
            }else{
              window.location = "/new-job";
            }
          }
        }
      }
    }else{
      if (auth ==='' || auth === null) {
        history.push('/');
      }
    }

}
 
export default CheckAuth;